import {ProfileData, User} from "../../../shared/models";


export const SET_USER = "SET_USER";
export const SET_PROFILE = "SET_PROFILE";

export const setUser = (user: User) => ({
  type: SET_USER,
  payload: user,
});

export const setProfile = (profileData: Partial<ProfileData>) => ({
  type: SET_PROFILE,
  payload: profileData,
});
